import './NewInvitesList.scss';

import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

type Props = {
  deleteStudent: (email: string) => void;
};

export const NewInvitesList = observer(({ deleteStudent }: Props) => {
  const iss = useStores().inviteStudentsStore;

  return (
    <ul className='new-invites-list'>
      {iss.newInvites.map((invite, index) => (
        <li key={`invite-${index}`} className='invite-item'>
          <div className='invite-data'>
            <div className='ordinal-number'>{index + 1}</div>
            <div className='name'>
              <strong>{invite.name}</strong>
            </div>
            <div className='email'>
              <span>{invite.email}</span>
            </div>
          </div>
          <button className='delete-button' onClick={() => deleteStudent(invite.email)}>
            <TrashIcon />
          </button>
        </li>
      ))}
    </ul>
  );
});

export default NewInvitesList;
